import cn from 'classnames';

import { getEnumStringValue, PortfolioTile_ThemeMap } from 'js/utils/enum-string-maps';

import Icon from 'components/icon/Icon';

import { IPortfolioTile } from 'source/NFR.types';

interface PortfolioTileProps extends IPortfolioTile {
  className?: string;
}

const PortfolioTile: React.FC<React.PropsWithChildren<PortfolioTileProps>> = ({ theme, className, children }) => {
  const iconName = getEnumStringValue(PortfolioTile_ThemeMap, theme);
  return (
    <div className={cn('portfolio-tile', className, iconName)}>
      {children}
      <Icon name={iconName ?? ''} />
    </div>
  );
};

PortfolioTile.displayName = 'PortfolioTile';

export default PortfolioTile;
